import { OverlayTabLayout } from '../OverlayTabLayout';
import { ActivityOverview } from './ActivityOverview';
import { DetailsCard } from './DetailsCard';

export const OverviewTab = () => (
  <OverlayTabLayout>
    <div className="w-full">
      <div className="flex gap-6">
        <div className="flex-1">
          <DetailsCard />
        </div>
        <div className="flex-1">
          <ActivityOverview />
        </div>
      </div>
    </div>
  </OverlayTabLayout>
);
